exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".show>.dropdown-menu-right{right:0;left:auto}\n", ""]);

